const ASSESSMENT_INVITATION_TOKEN_PATTERN = /(\/assessment-invitation\/)[^/?#\s]+/gi
const ENCODED_ASSESSMENT_INVITATION_TOKEN_PATTERN = /(%2fassessment-invitation%2f)[^&#\s]+/gi
const SENSITIVE_AUTH_QUERY_PARAMETER_PATTERN = /([?&](?:token|assessment)=)[^&#\s]*/gi
const SENSITIVE_EMAIL_QUERY_PARAMETER_PATTERN = /([?&]email=)[^&#\s]*/gi

export const sanitizeSentryUrl = value => {
	if (typeof value !== 'string') {
		return value
	}

	return value
		.replace(ASSESSMENT_INVITATION_TOKEN_PATTERN, '$1[token]')
		.replace(ENCODED_ASSESSMENT_INVITATION_TOKEN_PATTERN, '$1[token]')
		.replace(SENSITIVE_AUTH_QUERY_PARAMETER_PATTERN, '$1[token]')
		.replace(SENSITIVE_EMAIL_QUERY_PARAMETER_PATTERN, '$1[redacted]')
}

const sanitizeStringValues = values =>
	Object.fromEntries(
		Object.entries(values || {}).map(([key, value]) => [
			key,
			sanitizeSentryUrl(value)
		])
	)

export const sanitizeSentryBreadcrumb = breadcrumb => {
	if (!breadcrumb || typeof breadcrumb !== 'object') {
		return breadcrumb
	}

	const sanitized = {
		...breadcrumb,
		message: sanitizeSentryUrl(breadcrumb.message)
	}

	if (breadcrumb.data && typeof breadcrumb.data === 'object') {
		const sanitizedData = { ...breadcrumb.data }

		// Sentry's console integration stores the original values here. Axios
		// errors can include config.data, authorization details, and invitation
		// URLs even when the rendered breadcrumb message is harmless.
		if (breadcrumb.category === 'console') {
			delete sanitizedData.arguments
		}

		sanitized.data = {
			...sanitizedData,
			url: sanitizeSentryUrl(breadcrumb.data.url),
			from: sanitizeSentryUrl(breadcrumb.data.from),
			to: sanitizeSentryUrl(breadcrumb.data.to)
		}
	}

	return sanitized
}

export const sanitizeSentryEvent = event => {
	if (!event || typeof event !== 'object') {
		return event
	}

	const sanitized = {
		...event,
		message: sanitizeSentryUrl(event.message),
		transaction: sanitizeSentryUrl(event.transaction)
	}

	if (event.request && typeof event.request === 'object') {
		sanitized.request = {
			...event.request,
			url: sanitizeSentryUrl(event.request.url),
			headers:
				event.request.headers &&
				typeof event.request.headers === 'object'
					? sanitizeStringValues(event.request.headers)
					: event.request.headers
		}
	}

	if (Array.isArray(event.breadcrumbs)) {
		sanitized.breadcrumbs = event.breadcrumbs.map(sanitizeSentryBreadcrumb)
	}

	if (Array.isArray(event.exception?.values)) {
		sanitized.exception = {
			...event.exception,
			values: event.exception.values.map(value => ({
				...value,
				value: sanitizeSentryUrl(value?.value)
			}))
		}
	}

	return sanitized
}
